import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  task: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'task' }),
}

export { paths }
